export default __webpack_public_path__ + "resources/icons/n230-3aa1.png";